<template>
  <!-- 形式"< 1 2 3  ...  6>"" -->
   <div class="pagePagination">
    <span :disabled="props.currentPage <= 1" @click="handleClick(props.currentPage - 1)">&lt;</span>
    <span v-if="props.currentPage !== 1" @click="handleClick(1)">1</span>
    <span v-if="1 < props.currentPage - 2">...</span>
    <span v-if="props.currentPage - 2 > 0" @click="handleClick(props.currentPage - 1)">{{ props.currentPage - 1 }}</span>
    <span class="currentPageBtn">{{ props.currentPage }}</span>
    <span v-if="props.currentPage + 1 < props.totalpage" @click="handleClick(props.currentPage + 1)">{{ props.currentPage + 1 }}</span>
    <span v-if="props.totalpage > props.currentPage + 2">...</span>
    <span v-if="props.currentPage !== props.totalpage" @click="handleClick(props.totalpage)">{{ props.totalpage }}</span>
    <span :disabled="props.currentPage >= props.totalpage" @click="handleClick(props.currentPage + 1)">&gt;</span>
   </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'pagePagination',
  props: ['islastpage', 'totalpage', 'currentPage'],
  emits: ['update:currentpage'],
  setup (props, { emit }) {
    const hasNextPage = ref(true)
    const currentpage = ref(props.currentPage)

    hasNextPage.value = !props.islastpage
    console.log(props)

    const handleClick = (num) => {
      if (num < 1 || num > props.totalpage) {
        return
      }
      currentpage.value = num
      console.log('currentpage', currentpage.value)
      emit('update:currentpage', num)
    }

    return {
      props,
      handleClick
    }
  }
}
</script>

<style lang="less" scoped>
.pagePagination {
  display: flex;
  // gap: 100px;
  column-gap: 10px;
  span {
    flex: 1;
    border-radius: 10px;
    border: 1 solid;
    background-color: rgb(255, 255, 255);
    padding: 10px;
    text-align: center;
    cursor: pointer;
  }
  .currentPageBtn {
    background-color: rgb(234, 234, 234);
  }
}
</style>>
